import React, { createContext, useEffect, useState } from 'react';
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  sendPasswordResetEmail,
  updatePassword as updateFirebasePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from 'firebase/auth';
import { app2 } from '../firebase/firebase.config';

export const AuthContextTwo = createContext();
const auth = getAuth(app2);

const AuthProviderTwo = ({ children }) => {
  const [userTwo, setUser] = useState(null);
  const [loadingTwo, setLoading] = useState(true);

  const createUser = (email, password) => {
    setLoading(true);
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const signIn = (email, password) => {
    setLoading(true);
    return signInWithEmailAndPassword(auth, email, password);
  };

  const updateUser = (userInfo) => {
    return updateProfile(auth.currentUser, userInfo);
  };

  const sendPasswordResetEmaill = (email) => {
    return sendPasswordResetEmail(auth, email);
  };

  const updatePassword = (newPassword) => {
    return updateFirebasePassword(auth.currentUser, newPassword);
  };

  const logOutTwo = () => {
    setLoading(true);
    return signOut(auth);
  };

  const currentUser = () => {
    return auth.currentUser;
  };
  const changePassword = async (currentPassword, newPassword) => {
    if (!auth.currentUser) {
      throw new Error('No user is currently signed in');
    }

    // 1. Re-authenticate user
    const credential = EmailAuthProvider.credential(
      auth.currentUser.email,
      currentPassword
    );

    await reauthenticateWithCredential(auth.currentUser, credential);

    // 2. Once re-authenticated, update their password
    return updateFirebasePassword(auth.currentUser, newPassword);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log('user observing');
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const authInfo = {
    createUser,
    signIn,
    updateUser,
    logOutTwo,
    userTwo,
    sendPasswordResetEmaill,
    updatePassword,
    currentUser, // Add currentUser function to the authInfo object
    loadingTwo,
    changePassword,
  };

  return (
    <AuthContextTwo.Provider value={authInfo}>
      {children}
    </AuthContextTwo.Provider>
  );
};

export default AuthProviderTwo;
